export default {
  common: {
    save: "સેવ કરો",
    cancel: "રદ કરો",
    back: "પાછળ",
    submit: "સબમિટ કરો",
    loading: "લોડ થઈ રહ્યું છે…",
    yes: "હા",
    no: "ના",
    confirm: "પુષ્ટિ કરો",
    close: "બંધ કરો",
    search: "શોધો",
    all: "બધા",
    done: "થઈ ગયું",
    logout: "લૉગ આઉટ",
    language: "ભાષા",
    selectLanguage: "તમારી ભાષા પસંદ કરો",
    saving: "સેવ થઈ રહ્યું છે…",
    saved: "સેવ થયું",
    viewAll: "બધું જુઓ",
    filters: "ફિલ્ટર",
  },
  nav: {
    home: "હોમ",
    installs: "ઇન્સ્ટોલેશન",
    requests: "વિનંતીઓ",
    orders: "ઓર્ડર",
    profile: "પ્રોફાઇલ",
    leads: "લીડ્સ",
    service: "સેવા",
    payouts: "પેઆઉટ",
    toolkit: "ટૂલકિટ",
  },
  profile: {
    yourAccount: "તમારું ખાતું",
    title: "પ્રોફાઇલ.",
    city: "શહેર",
    state: "રાજ્ય",
    pinCode: "પિન કોડ",
    pinCodeHelp: "તમારો વિસ્તાર એ પરવાનગી પ્રાપ્ત વિસ્તાર છે જેમાં આ પિન કોડ આવે છે.",
    upiId: "યુપીઆઈ આઈડી (પેઆઉટ માટે)",
    saveProfile: "પ્રોફાઇલ સેવ કરો",
    preferredLanguage: "પસંદગીની ભાષા",
    logoutConfirm: "શું તમે ખરેખર લૉગ આઉટ કરવા માંગો છો?",
    linkedAddresses: "જોડાયેલા સરનામાં",
    noAddresses: "હજુ સુધી કોઈ સરનામું સેવ કરેલું નથી.",
    referFriend: "મિત્રને રેફર કરો",
    referFriendSub: "તમારો કોડ શેર કરો — તેઓ સોલાર લગાવે ત્યારે તમને ઈનામ મળશે.",
    myReferrals: "મારા રેફરલ્સ",
    shareFriend: "મિત્ર સાથે શેર કરો",
    secureNote: "તમારો ડેટા સુરક્ષિત ફોન ઓટીપી દ્વારા ચકાસાયેલ છે — કોઈ પાસવર્ડ યાદ રાખવાની કે ગુમાવવાની જરૂર નથી.",
    toolkit: "ટૂલકિટ",
    incentiveSchemes: "ઇન્સેન્ટિવ યોજનાઓ",
  },
  tickets: {
    myRequests: "મારી વિનંતીઓ",
    raiseComplaint: "ફરિયાદ નોંધાવો",
    cancelRequest: "વિનંતી રદ કરો",
    cancelConfirmTitle: "આ વિનંતી રદ કરવી છે?",
    cancelConfirmBody: "અમે આ સેવા વિનંતી પરનું કામ બંધ કરીશું. તમે પછી ફરીથી નવી વિનંતી કરી શકો છો.",
    cancelledToast: "વિનંતી રદ કરી",
    keepRequest: "ના, રહેવા દો",
    noRequests: "હજુ સુધી કોઈ સેવા વિનંતી નથી.",
    statusOpen: "ખુલ્લું",
    statusInProgress: "પ્રગતિમાં",
    statusOnHold: "રોકાયેલું",
    statusActionNeeded: "પગલાંની જરૂર",
    statusCompleted: "પૂર્ણ",
    statusClosed: "બંધ",
    statusCancelled: "રદ",
    statusDropped: "ડ્રોપ કરેલ",
    filterAll: "બધા",
    filterActive: "સક્રિય",
    filterResolved: "ઉકેલાયેલ",
    nonServiceable: "બિન-સેવાપાત્ર વિસ્તાર",
    raisedOn: "નોંધાવ્યું",
    ticketNumber: "ટિકિટ",
    wipInstall: "ઇન્સ્ટોલેશન ચાલુ",
    raisedByYou: "તમે નોંધાવ્યું",
    raisedByTeam: "અમારી ટીમે નોંધાવ્યું",
    timeline: "ટાઈમલાઈન",
    pending: "બાકી",
    resolutionSummary: "ઉકેલ સારાંશ",
    youRatedPrefix: "તમે આને રેટ કર્યું",
    howWasResolution: "ઉકેલ કેવો હતો?",
    submitFeedback: "ફીડબેક સબમિટ કરો",
  },
  home: {
    greeting: "નમસ્તે",
    newInstallation: "નવું ઇન્સ્ટોલેશન",
    raiseComplaint: "ફરિયાદ નોંધાવો",
    welcomeBack: "ફરી સ્વાગત છે",
    customerSubtitle: "પૂર્વોદય સાથે તમારી સોલાર યાત્રા, બધું એક જ જગ્યાએ.",
  },
  sc: {
    requestsTitle: "સેવા વિનંતીઓ",
    requestsForCustomers: "તમારા ગ્રાહકો માટે",
    kpiOpen: "ખુલ્લું",
    kpiResolved: "ઉકેલાયું",
    kpiInProblem: "સમસ્યામાં",
    raiseRequest: "સેવા વિનંતી નોંધાવો",
    slaBreached: "SLA ભંગ",
    viewPhotos: "ફોટા જુઓ",
    hidePhotos: "ફોટા છુપાવો",
    noRequestsWindow: "આ સમયગાળામાં કોઈ સેવા વિનંતી નથી.",
  },
};
